import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "mk-data-info-table",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_2 = ["width"]

import { PropType, ref } from 'vue'
import FormItem from '@/components/FormTable/FormItem.vue'


const __default__ = {
  name: "FormTable"
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  col: {
    type: Array as PropType<string[]>,
    default: ['30%', '70%']
  },
  formData: {
    type: Object,
    default: {}
  },
  formList: {
    type: Array as PropType<FormListType>,
    default: []
  },
  formatData: {
    type: Function
  },
  // 表单校验对象
  formRules: {
    type: Object,
    default: () => ({}),
  },
},
  setup(__props, { expose: __expose }) {

const props = __props;



const mForm = ref(null)

__expose({ mForm })

return (_ctx: any,_cache: any) => {
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, _mergeProps({
    model: __props.formData,
    rules: __props.formRules,
    "label-width": "0px",
    ref_key: "mForm",
    ref: mForm,
    class: "search-form"
  }, _ctx.$attrs), {
    default: _withCtx(() => [
      _createElementVNode("table", _hoisted_1, [
        _createElementVNode("colgroup", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.col, (c) => {
            return (_openBlock(), _createElementBlock("col", { width: c }, null, 8, _hoisted_2))
          }), 256))
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((__props.formList || []), (item, index) => {
            return (_openBlock(), _createBlock(FormItem, {
              "form-item": item,
              "form-data": __props.formData,
              "format-data": __props.formatData
            }, null, 8, ["form-item", "form-data", "format-data"]))
          }), 256)),
          _renderSlot(_ctx.$slots, "default")
        ])
      ])
    ]),
    _: 3
  }, 16, ["model", "rules"]))
}
}

})